import { ListPageSkeleton } from '@/components/PageSkeleton';
import { Skeleton } from '@/components/ui/skeleton';

/** 操作日志代码加载时的占位，按首次进入时的筛选区和空表布局展示 */
export function OperationLogSkeleton() {
  return (
    <div className="p-6 space-y-6" aria-hidden="true">
      <ListPageSkeleton
        columnCount={5}
        showPagination={false}
        contentClassName="gap-0 p-6"
        filterArea={
          <div className="flex items-end justify-between gap-4 pb-4">
            {/** 模块、操作人、日期和查询／重置按钮 */}
            <div className="flex-1">
              <div className="flex flex-wrap items-center gap-4">
                <Skeleton className="h-9 w-[180px]" />
                <Skeleton className="h-9 w-[180px]" />
                <Skeleton className="h-9 w-[260px]" />
                <div className="flex items-center gap-2">
                  <Skeleton className="h-9 w-20" />
                  <Skeleton className="h-9 w-20" />
                </div>
              </div>
            </div>
            {/** 列配置入口 */}
            <Skeleton className="h-9 w-24 shrink-0" />
          </div>
        }
      />
    </div>
  );
}
